module.exports = function getResource(label, vars = []) {
    let resources = {
        beautyMatch: 'Correspondance beauté',
        beautyMatches: 'Correspondances beauté'
    };
    return resources[label];
};
